var React = require('react');

const notFound = React.createClass({
    render: function () {
        return (
            <div>
                Page Not Found
            </div>
        )
    }
});

module.exports = notFound;


// WEBPACK FOOTER //
// ./modules/notFound.jsx